import React from 'react';
import { IStorefrontOrderProduct } from '../../../models/Storefront';
import { DetailsList, IColumn, SelectionMode } from '@fluentui/react';
import {
    ColumnGenerator,
    CurrencyColumnGenerator,
    IconButtonColumnGenerator
} from '../../../logic/Columns/ColumnGenerator';
import DetailsModal from "../../DetailsModal/DetailsModal";
import {useGetOrganizationQuery} from "../../../store/endpoints/OrganizationsEndpoints";
import {useSelector} from "react-redux";
import {RootState} from "../../../store/rootReducer";

interface IStorefrontOrderProductsTableProps {
    products: IStorefrontOrderProduct[];
}

const StorefrontOrderProductsTable: React.FC<IStorefrontOrderProductsTableProps> = (props) => {
    const [showModal, setShowModal] = React.useState(false);
    const [selectedProduct, setSelectedProduct] = React.useState<IStorefrontOrderProduct | undefined>();
    const selectedOrganization = useSelector((state: RootState) => state.settings.selectedOrganization);
    const getOrganization = useGetOrganizationQuery(selectedOrganization ?? '', {skip: !selectedOrganization || selectedOrganization === ''});
    const columns: IColumn[] = [
        IconButtonColumnGenerator((item: IStorefrontOrderProduct) => {setSelectedProduct(item); setShowModal(true)}, 'view', ""),
        ColumnGenerator('Product', 'name', 100),
        CurrencyColumnGenerator('Price', 'price', 100, 100),
        ColumnGenerator('Quantity', 'quantity', 100, 100),
    ]
    return (
        <>
            <DetailsList
                selectionMode={SelectionMode.none}
                items={props.products}
                columns={columns}
            />
            {selectedProduct?.productId && getOrganization.data?.defaultCatalog &&
            <DetailsModal product={selectedProduct.productId} catalog={getOrganization.data.defaultCatalog} open={showModal} onClose={() => setShowModal(false)} />
            }
        </>
    )
}

export default StorefrontOrderProductsTable;